import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import type { ReactElement, ReactNode } from "react";

import "overlayscrollbars/overlayscrollbars.css";

export interface ScrollbarsProps {
  children: ReactNode;
  className?: string;
}

export default function Scrollbars({
  children,
}: ScrollbarsProps): ReactElement {
  return (
    <OverlayScrollbarsComponent defer className=" h-full w-full">
      {children}
    </OverlayScrollbarsComponent>
  );
}
